export default __webpack_public_path__ + "static/media/hht1_storybook_11.c0d9edbe.png";